module.exports = __webpack_public_path__ + "img/album18_58.2d2ec6d9.jpg";